require('../../../assets/lib/jquery/jquery-ui-1.13.2.min.js');
require('../../../assets/scripts/jhire/services/jv.services.js');
require('../../../assets/scripts/common/jv.Filters.js');
require('../../../assets/scripts/common/jv.currentUser.service.js');
require('../../../assets/lib/js/angularmodule/angservice.js');
require('../../../assets/scripts/source/tasks/JV.Tasks.select2Service.js');
require('../../../assets/lib/js/angularmodule/angdirective.js');
require('../../../assets/lib/js/JV.FriendWidget_js_upgrade.webpack.js');
require('../../../assets/scripts/source/tasks/JV.TasksDirective.js');
require('../../../assets/scripts/source/tasks/JV.Tasks.js');
require('../../../assets/scripts/common/directives/jv.Datepicker.js');
require('../../../assets/scripts/common/jv.Modal.js');
require('../../../assets/scripts/jhire/services/jv.Hire.Url.Service.js');